import styled from '@emotion/styled'

import { ButtonLink } from '@/legacy/components/Button'
import { CONFIG } from '@/ui/shared/styles'

import { Container } from '../Container'

export const SectionStyles = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;

  .partner__description {
    color: rgba(var(--theme-text-dark-medium));
  }
`

export const ContainerStyles = styled(Container)`
  margin-bottom: 1rem;

  .search-partner {
    padding: 0 0.75rem;
    background-color: rgb(var(--theme-white));

    input::placeholder {
      color: rgba(var(--theme-text-dark-low)) !important;
    }
  }

  .icon__magnifier {
    display: flex;
    align-items: center;
    color: rgba(var(--colors-primary));
  }

  .result-search-partner {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
  }
  .space {
    margin-bottom: 2rem;
  }
  .result-option {
    width: 100%;
    text-align: center;
  }
  .access-partner {
    color: rgba(var(--colors-primary));
    text-decoration: underline;
  }
`

export const OrderOptionStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  margin-bottom: 2.5rem;

  button {
    border: none;
    padding: 0;
    background-color: transparent;
    cursor: pointer;
  }

  .selector-order {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    color: rgba(var(--theme-text-dark-medium));
    margin-top: 1rem;
  }

  fieldset {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    z-index: 1;
    width: 14rem;
    height: 8rem;
    margin: 3rem 0;

    border-radius: 0.5rem;
    border: 0.0625rem solid #dedfe3;
    background: rgb(var(--theme-white));
    box-shadow: var(--theme-box-shadow);
  }

  .angle-left {
    transform: rotate(-90deg);
  }
`
interface PropsPartner {
  hasPartner: boolean
}

export const ListPartnerStyle = styled.ol<PropsPartner>`
  display: ${(props) => (props.hasPartner ? 'grid' : 'flex')};
  flex-direction: ${(props) => (props.hasPartner ? '' : 'column')};
  grid-template-columns: repeat(auto-fit, minmax(14rem, auto));
  justify-content: center;

  margin-top: 2rem;
  gap: 1rem 0.5rem;

  ${CONFIG.media.mobileSm} {
    display: flex;
    flex-wrap: wrap;
  }
`

export const PartnerItemStyle = styled.li`
  display: flex;
  align-items: center;
  flex-direction: column;

  height: 8.75rem;
  gap: 0.5rem;

  border-radius: 0.625rem;
  border: 0.063rem solid rgba(var(--theme-surface-silver));
  background: rgb(var(--theme-white));

  .image {
    width: 100%;
    max-width: 7rem;
    margin-top: 0.5rem;
  }
  ${CONFIG.media.mobileSm} {
    flex-grow: 1;
    width: 14rem;
  }
`

export const ButtonStyle = styled(ButtonLink)`
  width: 90%;
  height: 2.25rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;

  &:focus {
    box-shadow: 0px 0px 1px 4px rgba(var(--colors-primary), 0.3);
    border-color: rgba(var(--colors-primary));
  }
`
